import cc from 'classcat';

const keys = (...objects) => [
  ...new Set(objects.reduce((a, x) => [...a, ...Object.keys(x)], [])),
];

// no particular reason this has to be a hook. exported as both for convenience
export const mergeStyles = (...objects) => {
  const styles = objects.filter(Boolean);
  return keys(...styles).reduce(
    (acc, key) => ({
      ...acc,
      [key]: cc(styles.map((s) => s[key])),
    }),
    {}
  );
};

export const useMergedStyles = mergeStyles;
